import Color from '../models/color';
import Solver from '../models/solver';
import RGB from '../models/rgb';

export default function cssFilter(hex: string | undefined) {
  if (!hex) return {};

  const rgbColor = new RGB(hex);

  if (!rgbColor.rgb || rgbColor.rgb.length !== 3) {
    return {};
  }

  const color = new Color({
    r: rgbColor.rgb[0],
    g: rgbColor.rgb[1],
    b: rgbColor.rgb[2]
  });
  const solver = new Solver(color);
  const result = solver.solve();

  return result.filter;
}
